import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons'
import footerLogo from '../../media/maverickscc_logo.png'

export default function Footer() {
  return (
    <>
      <footer>
        <div className='container'>
          <div className='row py-5'>
            <div className='col-lg-6'>
              <img src={footerLogo} alt='Maverickscc Logo' />
              <p>
                Mavericks Sports Foundation is a registered 501(c)(3) nonprofit organization where
                cricket meets community. Join us in our mission to harness the power of cricket to
                drive positive change and make a lasting impact around the world. Proudly part of
                the American Cricket League, the Mavericks Sports Foundation is committed to using
                sport as a force for good.
              </p>
              <div className='footer-social-links'>
                <a href='https://www.facebook.com/Mavscc' target='_blank'>
                  <FontAwesomeIcon icon={faFacebookF} className='icon facebook' />
                </a>
                <a href='https://www.instagram.com/mavericks.cricket/'>
                  <FontAwesomeIcon icon={faInstagram} className='icon instagram' />
                </a>
              </div>
            </div>
            <div className='col-lg-6'>
              <h3> Other Links </h3>
              <ul className='footer-links'>
                <li> Privacy Policy </li> <li> Terms & Conditions </li> <li> Locations </li>
                <li>
                  <Link to='series'> Series </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className='row'>
            <div className='copyright'>
              <p> ©Copyright 2025 Mavericks Sports Foundation.All Rights Reserved. </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
